import type { ActiveTab } from '@/state/store';
import { useAppStore } from '@/state/store';

const TABS: Array<{ id: ActiveTab; label: string }> = [
  { id: 'viewer', label: '3D Viewer' },
  { id: 'inspector', label: 'Profile Inspector' },
  { id: 'info', label: 'Model Information' },
  { id: 'library', label: 'Library' },
];

export function TabBar() {
  const activeTab = useAppStore((s) => s.activeTab);
  const setActiveTab = useAppStore((s) => s.setActiveTab);
  const gapCount = useAppStore((s) => s.model?.trim.gaps.filter((g) => !g.filled).length ?? 0);

  return (
    <div className="tab-bar" role="tablist" aria-label="Model views">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`tab-button${activeTab === tab.id ? ' is-active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.label}
          {tab.id === 'inspector' && gapCount > 0 && (
            <span
              title={`${gapCount} possible missing-geometry region(s) detected`}
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: 'var(--danger)',
                display: 'inline-block',
              }}
            />
          )}
        </button>
      ))}
    </div>
  );
}
